import { parseTime } from '../../../utils/secondsToDuration.js'
import { parseXml } from '../../../utils/xmlParser/parseXml'

/** Receive an XML VAST v3 document and extract the video URL, skip duration and event URLs */
export function extractVastInfo(vastXML) {
  const xmlDoc = parseXml(vastXML)

  const adSystemNode = xmlDoc.getElementsByTagName('AdSystem')[0]
  const mediaFileNode = xmlDoc.getElementsByTagName('MediaFile')[0]

  const skipOffset = xmlDoc.getElementsByTagName('Linear')[0]?.getAttribute('skipoffset')
  const duration = xmlDoc.getElementsByTagName('Duration')[0]?.textContent.trim()

  const trackingEvents = Array.from(xmlDoc.getElementsByTagName('Tracking')).map((node) => [
    node.getAttribute('event'),
    node.textContent.trim(),
  ])

  const mediaUrl = mediaFileNode?.textContent.trim()

  return {
    adId: xmlDoc.getElementsByTagName('Ad')[0]?.getAttribute('id') ?? '',
    adSystem: adSystemNode && {
      version: adSystemNode.getAttribute('version'),
      value: adSystemNode.textContent,
    },
    adTitle: xmlDoc.getElementsByTagName('AdTitle')[0]?.textContent ?? '',
    errorUrl: xmlDoc.getElementsByTagName('Error')[0]?.textContent.trim() ?? '',
    impressionUrl: xmlDoc.getElementsByTagName('Impression')[0]?.textContent.trim() ?? '',
    clickThroughUrl: xmlDoc.getElementsByTagName('ClickThrough')[0]?.textContent.trim(),
    mediaFile: mediaUrl && {
      url: mediaUrl,
      mime: mediaFileNode.getAttribute('type'),
      duration: duration && parseTime(duration),
      bitrate: mediaFileNode.getAttribute('bitrate'),
      delivery: mediaFileNode.getAttribute('delivery'),
      width: mediaFileNode.getAttribute('width'),
      height: mediaFileNode.getAttribute('height'),
    },
    skip: skipOffset && {
      offset: parseTime(skipOffset),
    },
    trackingEvents: Object.fromEntries(trackingEvents),
  }
}
